import getConfig from "next/config";
import { useDispatch, useSelector } from "react-redux";

import { setCookie } from "common/cookies";
import { FulfillmentPreference } from "custom-types/User";
import { USER_FULFILLMENT_PREFERENCE_CHANGE } from "redux/reducers/user";
import { getDomainCountryCode } from "redux/selectors/config";
import { getUserFulfillmentPreference } from "redux/selectors/user";

const useUserFulfillmentPreference = () => {
  const countryCode = useSelector(getDomainCountryCode);
  const {
    publicRuntimeConfig: { cookieDomainCa, cookieDomain },
  } = getConfig();
  const dispatch = useDispatch();

  const setUserFulfillmentPreference = (preference: string) => {
    setCookie(
      "userFulfillmentPreference",
      // @ts-ignore (fix me please, do not replicate)
      FulfillmentPreference[preference.toUpperCase()] ||
        FulfillmentPreference.DELIVERY,
      countryCode === "CA" ? cookieDomainCa : cookieDomain
    );

    dispatch({
      fulfillmentPreference: preference,
      type: USER_FULFILLMENT_PREFERENCE_CHANGE,
    });
  };

  return {
    setUserFulfillmentPreference,
    userFulfillmentPreference: useSelector(getUserFulfillmentPreference),
  };
};

export default useUserFulfillmentPreference;
